import React, { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  it: {
    nav: { home: "Home", services: "Servizi", fleet: "Flotta", destinations: "Destinazioni", about: "Chi Siamo", contacts: "Contatti", booking: "Prenota" },
    common: {
      bookNow: "Prenota Ora", whatsapp: "WhatsApp", email: "Email", callUs: "Chiamaci",
      requestQuote: "Richiedi Preventivo", discover: "Scopri", viewAll: "Vedi Tutto",
      passengers: "Passeggeri", luggage: "Bagagli", getInTouch: "Contattaci",
    },
    legal: {
      consent: "Ho letto e accetto la",
      privacyLink: "Privacy Policy",
      consentReq: "Per proseguire devi accettare la Privacy Policy.",
      cookieText: "Utilizziamo cookie tecnici e, previo consenso, cookie per migliorare la tua esperienza. Continuando accetti la nostra Privacy Policy.",
      cookieAccept: "Accetta",
      cookieDecline: "Rifiuta",
    },
    hero: {
      tag: "Chauffeur di Lusso · Napoli & Sud Italia",
      title1: "L'arte del", title2: "viaggio esclusivo",
      subtitle: "Servizio NCC premium con autista privato. Trasferimenti, tour ed esperienze su misura nel cuore del Mediterraneo.",
      cta: "Prenota il tuo viaggio", cta2: "Esplora i servizi",
    },
    home: {
      introTag: "Benvenuti in NC&C Luxury",
      introTitle: "Eleganza in movimento, discrezione ad ogni chilometro",
      introText: "NC&C Luxury è sinonimo di trasporto d'élite in Campania e nel Sud Italia. Autisti professionali, veicoli di rappresentanza e un'attenzione maniacale al dettaglio per una clientela che non accetta compromessi.",
      statsClients: "Clienti VIP serviti", statsYears: "Anni di esperienza", statsCities: "Destinazioni coperte", statsRating: "Valutazione media",
      servicesTag: "I nostri servizi", servicesTitle: "Un'esperienza per ogni esigenza",
      fleetTag: "La nostra flotta", fleetTitle: "Veicoli di rappresentanza",
      destTag: "Destinazioni", destTitle: "Il Sud Italia come non l'avete mai vissuto",
      ctaTitle: "Pronti a viaggiare in stile?", ctaText: "Prenotate il vostro chauffeur privato in pochi istanti.",
    },
    services: {
      tag: "Servizi", title: "Servizi su misura per una clientela esigente",
      subtitle: "Dai trasferimenti aeroportuali agli eventi più esclusivi, ogni servizio è progettato attorno a voi.",
    },
    fleet: {
      tag: "Flotta", title: "Comfort, sicurezza e prestigio",
      subtitle: "Una selezione di veicoli premium, mantenuti impeccabilmente e guidati da autisti esperti.",
    },
    destinations: {
      tag: "Destinazioni", title: "Esperienze indimenticabili nel Sud Italia",
      subtitle: "Vi accompagniamo verso le mete più iconiche del Mediterraneo con eleganza e riservatezza.",
    },
    about: {
      tag: "Chi Siamo", title: "La nostra filosofia: il lusso è nel dettaglio",
      p1: "NC&C Luxury nasce a Napoli dalla passione per l'ospitalità e l'eccellenza. Offriamo un servizio di noleggio con conducente pensato per chi desidera viaggiare con la massima comodità, puntualità e riservatezza.",
      p2: "Ogni autista è selezionato per professionalità e conoscenza del territorio. Ogni veicolo è un ambiente curato nei minimi particolari. Il nostro obiettivo è trasformare ogni spostamento in un'esperienza memorabile.",
      values: "I nostri valori",
      v1t: "Puntualità", v1d: "Il vostro tempo è prezioso. Siamo sempre in anticipo.",
      v2t: "Riservatezza", v2d: "Discrezione assoluta per clienti privati e business.",
      v3t: "Eccellenza", v3d: "Veicoli premium e standard di servizio impeccabili.",
      v4t: "Su misura", v4d: "Ogni viaggio è personalizzato sulle vostre esigenze.",
    },
    contacts: {
      tag: "Contatti", title: "Siamo a vostra disposizione",
      subtitle: "Contattateci per prenotazioni, preventivi o richieste speciali. Rispondiamo in tempi rapidi, 24/7.",
      phone: "Telefono", writeUs: "Scriveteci", formTitle: "Inviaci un messaggio",
      namePh: "Il vostro nome", emailPh: "La vostra email", phonePh: "Telefono (opzionale)", msgPh: "Il vostro messaggio",
      send: "Invia messaggio", sent: "Messaggio inviato con successo!", area: "Zona operativa", areaText: "Napoli, Costiera Amalfitana, Sorrento, Salerno e tutto il Sud Italia.",
    },
    booking: {
      tag: "Prenotazione", title: "Richiedi la tua prenotazione",
      subtitle: "Compila il modulo e il nostro team ti ricontatterà per confermare ogni dettaglio del tuo viaggio.",
      date: "Data", time: "Orario", route: "Tragitto (da → a)", routePh: "Es. Aeroporto Napoli → Positano",
      pickup: "Partenza", pickupPh: "Indirizzo o luogo di partenza", destination: "Destinazione", destinationPh: "Indirizzo o luogo di arrivo",
      passengers: "Passeggeri", luggage: "Bagagli", serviceType: "Tipo di servizio", selectService: "Seleziona un servizio",
      name: "Nome e cognome", phone: "Telefono", email: "Email", message: "Note aggiuntive", messagePh: "Indica il numero di volo o treno, l'orario di arrivo e ogni richiesta speciale...",
      emailHint: "Importante: verifica che l'email sia corretta — la useremo per inviarti la conferma della prenotazione.",
      messageHint: "Consiglio: specifica il numero del volo o del treno e l'orario di arrivo per un servizio puntuale.",
      submit: "Invia richiesta", submitting: "Invio in corso...", success: "Richiesta inviata! Ti ricontatteremo a breve.",
      orContact: "Oppure contattaci direttamente", pickDate: "Scegli una data",
    },
    footer: {
      tagline: "Chauffeur di lusso e trasporti premium a Napoli e nel Sud Italia.",
      quickLinks: "Navigazione", contactInfo: "Contatti", followText: "Prenota il tuo viaggio esclusivo oggi stesso.",
      rights: "Tutti i diritti riservati.", privacy: "Privacy Policy",
    },
  },
  en: {
    nav: { home: "Home", services: "Services", fleet: "Fleet", destinations: "Destinations", about: "About Us", contacts: "Contacts", booking: "Booking" },
    common: {
      bookNow: "Book Now", whatsapp: "WhatsApp", email: "Email", callUs: "Call Us",
      requestQuote: "Request a Quote", discover: "Discover", viewAll: "View All",
      passengers: "Passengers", luggage: "Luggage", getInTouch: "Get in Touch",
    },
    legal: {
      consent: "I have read and accept the",
      privacyLink: "Privacy Policy",
      consentReq: "You must accept the Privacy Policy to continue.",
      cookieText: "We use technical cookies and, with your consent, cookies to improve your experience. By continuing you accept our Privacy Policy.",
      cookieAccept: "Accept",
      cookieDecline: "Decline",
    },
    hero: {
      tag: "Luxury Chauffeur · Naples & Southern Italy",
      title1: "The art of", title2: "exclusive travel",
      subtitle: "Premium chauffeur service with private driver. Bespoke transfers, tours and experiences in the heart of the Mediterranean.",
      cta: "Book your journey", cta2: "Explore services",
    },
    home: {
      introTag: "Welcome to NC&C Luxury",
      introTitle: "Elegance in motion, discretion at every mile",
      introText: "NC&C Luxury is synonymous with elite transport in Campania and Southern Italy. Professional chauffeurs, executive vehicles and obsessive attention to detail for a clientele that accepts no compromise.",
      statsClients: "VIP clients served", statsYears: "Years of experience", statsCities: "Destinations covered", statsRating: "Average rating",
      servicesTag: "Our services", servicesTitle: "An experience for every need",
      fleetTag: "Our fleet", fleetTitle: "Executive vehicles",
      destTag: "Destinations", destTitle: "Southern Italy like never before",
      ctaTitle: "Ready to travel in style?", ctaText: "Book your private chauffeur in just a few moments.",
    },
    services: {
      tag: "Services", title: "Tailored services for a discerning clientele",
      subtitle: "From airport transfers to the most exclusive events, every service is designed around you.",
    },
    fleet: {
      tag: "Fleet", title: "Comfort, safety and prestige",
      subtitle: "A curated selection of premium vehicles, impeccably maintained and driven by expert chauffeurs.",
    },
    destinations: {
      tag: "Destinations", title: "Unforgettable experiences in Southern Italy",
      subtitle: "We take you to the most iconic Mediterranean destinations with elegance and discretion.",
    },
    about: {
      tag: "About Us", title: "Our philosophy: luxury is in the detail",
      p1: "NC&C Luxury was born in Naples from a passion for hospitality and excellence. We offer a chauffeur-driven service designed for those who wish to travel with the utmost comfort, punctuality and discretion.",
      p2: "Every chauffeur is selected for professionalism and local knowledge. Every vehicle is an environment crafted down to the smallest detail. Our goal is to turn every journey into a memorable experience.",
      values: "Our values",
      v1t: "Punctuality", v1d: "Your time is precious. We are always ahead of schedule.",
      v2t: "Discretion", v2d: "Absolute confidentiality for private and business clients.",
      v3t: "Excellence", v3d: "Premium vehicles and impeccable service standards.",
      v4t: "Bespoke", v4d: "Every journey is tailored to your needs.",
    },
    contacts: {
      tag: "Contacts", title: "We are at your service",
      subtitle: "Contact us for bookings, quotes or special requests. We reply quickly, 24/7.",
      phone: "Phone", writeUs: "Write to us", formTitle: "Send us a message",
      namePh: "Your name", emailPh: "Your email", phonePh: "Phone (optional)", msgPh: "Your message",
      send: "Send message", sent: "Message sent successfully!", area: "Operating area", areaText: "Naples, Amalfi Coast, Sorrento, Salerno and all of Southern Italy.",
    },
    booking: {
      tag: "Booking", title: "Request your booking",
      subtitle: "Fill in the form and our team will get back to you to confirm every detail of your journey.",
      date: "Date", time: "Time", route: "Route (from → to)", routePh: "E.g. Naples Airport → Positano",
      pickup: "Pickup", pickupPh: "Pickup address or place", destination: "Destination", destinationPh: "Drop-off address or place",
      passengers: "Passengers", luggage: "Luggage", serviceType: "Service type", selectService: "Select a service",
      name: "Full name", phone: "Phone", email: "Email", message: "Additional notes", messagePh: "Specify your flight or train number, arrival time and any special request...",
      emailHint: "Important: please make sure your email is correct — we'll use it to send your booking confirmation.",
      messageHint: "Tip: specify your flight or train number and arrival time for a punctual service.",
      submit: "Send request", submitting: "Sending...", success: "Request sent! We'll get back to you shortly.",
      orContact: "Or contact us directly", pickDate: "Pick a date",
    },
    footer: {
      tagline: "Luxury chauffeur and premium transport in Naples and Southern Italy.",
      quickLinks: "Navigation", contactInfo: "Contacts", followText: "Book your exclusive journey today.",
      rights: "All rights reserved.", privacy: "Privacy Policy",
    },
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ncc_lang") || "it");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("ncc_lang", l);
    document.documentElement.lang = l;
  }, []);

  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = translations[lang];
    for (const p of parts) {
      node = node?.[p];
      if (node === undefined) return path;
    }
    return node;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
